import { render, staticRenderFns } from "./OpenSourceApiCard.vue?vue&type=template&id=294889d7&scoped=true"
import script from "./OpenSourceApiCard.vue?vue&type=script&lang=ts"
export * from "./OpenSourceApiCard.vue?vue&type=script&lang=ts"
import style0 from "./OpenSourceApiCard.vue?vue&type=style&index=0&id=294889d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294889d7",
  null
  
)

export default component.exports